module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-14-5218802ab0c3f2286934fb9714e6cb5a.jpg";